import * as React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

// MUI Icons
import TranslateIcon from '@mui/icons-material/Translate';

// Custom Components
import HeaderMenuButton from '@/ui/Header/HeaderMenuButton';
import HeaderMenuItem from '@/ui/Header/HeaderMenuItem';

import TenantContext, { TenantContextType } from '@/context/TenantContext/TenantContext';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const tenantContext = React.useContext(TenantContext);
  const { languages } = tenantContext as TenantContextType;

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  const handleLanguageChange = (lang: string) => {
    localStorage.setItem('i18nextLng', lang);
    i18n.changeLanguage(lang);
  };

  return (
    <HeaderMenuButton text={i18n.language} startIcon={mdUp ? <TranslateIcon /> : null} showExpandIcon={mdUp} desc="language">
      {languages.map((lang) => (
        <HeaderMenuItem
          key={`${lang.title}-menu-item`}
          label={lang.title}
          onClick={() => {
            handleLanguageChange(lang.code);
          }}
        />
      ))}
    </HeaderMenuButton>
  );
};

export default LanguageSelector;
